import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Creating Your Metamodel",
description: "Define the core metamodel for your Freon-based DSL by introducing model units (Topic, Flow, Test, SiteGroup), concepts, references, and limited concepts, and organize your definition files for generation.",
tags: [ "Freon", "metamodel", "model units", "AST", "Topic", "Flow", "Test", "SiteGroup", "Page", "references", "UML", "limited concept", "enumeration", "Education language", "tutorial"] ,
modifiedTime: "2025-11-07T18:52:21.430Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};